import axios from "axios";
import config from "../../config/constants";
import {
  loadProcessToken,
  showErrorToaster,
} from "./index";
import {toastr} from "react-redux-toastr";

export const INFERENCE_LOADING = 'INFERENCE_LOADING';
export const FETCH_INFERENCE_SUCCESS = 'FETCH_INFERENCE_SUCCESS';
export const CREATE_INFERENCE = 'CREATE_INFERENCE';
export const UPDATE_INFERENCE = 'UPDATE_INFERENCE';
export const DELETE_INFERENCE = 'DELETE_INFERENCE';
export const OPEN_INFERENCE = 'OPEN_INFERENCE';
export const FETCH_AI_MODELS_SUCCESS = 'FETCH_AI_MODELS_SUCCESS';
export const SET_EXECUTION_TYPE = 'SET_EXECUTION_TYPE';

const inferenceLoading = payload => ({
  type: INFERENCE_LOADING,
  payload,
});

export const openInference = (props, scope) => (dispatch, getState) => {
  dispatch({
    type: OPEN_INFERENCE,
    payload: props
  });
  if (props && props.collection_id) {
    dispatch(getAiModelsInference({collection_id: props.collection_id}));
  }
};

export const getInference = (props = {}, scope) => (dispatch, getState) => {
  const token = loadProcessToken();
  dispatch(inferenceLoading(true));
  const page = props && props.page ? props.page + 1 : 1;
  const perPage = props && props.perPage ? props.perPage : 20;
  const filterFieldData =
    props && props.filterFieldData
      ? props.filterFieldData.trim() : '';

  axios.get(
    config.API_URL + 'ai4ai/ism?' + filterFieldData +
    '&page=' + page + '&per_page=' + perPage
  )
    .then(({ data }) => {
      if (data){
        dispatch({
          type: FETCH_INFERENCE_SUCCESS,
          payload: data
        });
        dispatch(inferenceLoading(false));
      }
    })
    .catch(function (error) {
      showErrorToaster(error, "Unknown Error in retrieving inference", "Please refer the console logs for more details on the error.");
    });
};

export const getAiModelsInference = (props = {}, scope) => (dispatch, getState) => {
  dispatch(inferenceLoading(true));
  const page = props && props.page ? props.page + 1 : 1;
  const perPage = props && props.perPage ? props.perPage : 20;
  const filterFieldData =
    props && props.filterFieldData
      ? props.filterFieldData.trim() : '';

  axios.get(
    config.API_URL + 'ai4ai/entities/collection/ai_models/'+ props.collection_id +'?' + filterFieldData +
    '&page=' + page + '&per_page=' + perPage
  )
    .then(({ data }) => {
      if (data){
        dispatch({
          type: FETCH_AI_MODELS_SUCCESS,
          payload: data.data && data.data.ai_model_list
        });
        dispatch(inferenceLoading(false));
      }
    })
    .catch(function (error) {
      showErrorToaster(error, "Unknown Error in retrieving inference", "Please refer the console logs for more details on the error.");
    });
};

export const createOrUpdateInference = (props, history) => (dispatch, getState) => {
  if(props._id) {
    axios.put(config.API_URL + 'ai4ai/ism', props)
      .then(({ data }) => {
        dispatch({
          type: UPDATE_INFERENCE,
          payload: data.data
        });
        history.push('inference');
        toastr.success('Successfully update the inferences');
      }).catch(function (error) {
      showErrorToaster(error, "Unknown Error in updating inferences", "Please refer the console logs for more details on the error.");
    });
  } else {
    return axios.post(config.API_URL + 'ai4ai/ism', props)
      .then(({ data }) => {
        dispatch({
          type: CREATE_INFERENCE,
          payload: data.data
        });
        history.push('inference');
        toastr.success('Successfully created the inference');
      }).catch(function (error) {
        showErrorToaster(error, "Unknown Error in creating inferences", "Please refer the console logs for more details on the error.");
      });
  }
};

export const deleteInferece = (props, scope) => (dispatch, getState) => {
  return axios.delete(config.API_URL + 'ai4ai/ism/' + props._id)
    .then(({ data }) => {
      dispatch({
        type: DELETE_INFERENCE,
        payload: props._id
      });
      toastr.success('Successfully deleted the inference');
    }).catch(function (error) {
      showErrorToaster(error, "Unknown Error in deleting inference", "Please refer the console logs for more details on the error.");
    });
};

export const setExecutionType = (props, scope) => {
  console.log("Received SET_EXECUTION_TYPE dispatch");
  return (dispatch, getState) => {
    dispatch({
      type: SET_EXECUTION_TYPE,
      payload: props
    });
    console.log(" SET_EXECUTION_TYPE dispatched");
  };
}

